// extracted by mini-css-extract-plugin
export default {"layout":"Vp8TW___App-module__layout","header":"xnK5m___App-module__header","breadcrumbsContainer":"QDUBE___App-module__breadcrumbsContainer"};